export default class AuthenticationModel {
  token: string;

  constructor() {
    this.token = "";
  }
}
